import { toast } from "react-toastify";

export const RESERVED_FUNCTION_KEYS = {
    DPO: "dpo",
    AI_GOVERNANCE: "ai_governance",
    IT_SECURITY: "it_security",
};

export const ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY = [
    "gdpr-organization-functions-list",
];

export const getOrganizationFunctionQueryKey = (key) => [
    "gdpr-organization-function",
    key,
];

export const ORGANIZATION_FUNCTION_ERROR_CODES = {
    NOT_FOUND: "error.organization_function_not_found",
    TITLE_REQUIRED: "error.organization_function_title_required",
    KEY_IMMUTABLE: "error.organization_function_key_immutable",
    DEFAULT_CANNOT_DELETE: "error.organization_function_default_cannot_delete",
    DPO_ALREADY_ASSIGNED: "error.organization_function_dpo_already_assigned",
    REPLACE_DPO_ONLY: "error.organization_function_replace_dpo_only",
    CROSS_ORG_FORBIDDEN: "error.organization_function_cross_org_forbidden",
    ROUTING_USER_NOT_MEMBER:
        "error.organization_function_routing_user_not_member",
};

export const isDpo = (key) => key === RESERVED_FUNCTION_KEYS.DPO;

export const isReservedFunction = ({ key, is_default } = {}) => {
    if (is_default) {
        return true;
    }

    return Object.values(RESERVED_FUNCTION_KEYS).includes(key);
};

export const extractOrganizationFunction = (payload) => {
    if (!payload || typeof payload !== "object") {
        return null;
    }

    if (
        payload.function &&
        typeof payload.function === "object" &&
        !Array.isArray(payload.function)
    ) {
        return payload.function;
    }

    if (
        payload.data?.function &&
        typeof payload.data.function === "object" &&
        !Array.isArray(payload.data.function)
    ) {
        return payload.data.function;
    }

    if (
        payload.data &&
        typeof payload.data === "object" &&
        !Array.isArray(payload.data) &&
        (payload.data.key || payload.data.title)
    ) {
        return payload.data;
    }

    if (payload.key || payload.title) {
        return payload;
    }

    return null;
};

export const getOrganizationFunctionErrorCode = (error) => {
    const data = error?.response?.data;

    if (!data) {
        return null;
    }

    if (typeof data.error === "string") {
        return data.error;
    }

    if (typeof data.message === "string") {
        return data.message;
    }

    if (typeof data.message?.error === "string") {
        return data.message.error;
    }

    return null;
};

export const toastOrganizationFunctionError = (error, t, fallbackKey) => {
    const code = getOrganizationFunctionErrorCode(error);
    const knownCodes = Object.values(ORGANIZATION_FUNCTION_ERROR_CODES);

    if (code && knownCodes.includes(code)) {
        toast(t(code), {
            type: "error",
        });

        return code;
    }

    toast(t(fallbackKey), {
        type: "error",
    });

    return code;
};
